import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../components/general/ImageCustom'
import { ArrowLeft, RotateCw, Table, X } from 'react-feather'

const PosNav = ({ orderDetail, handleClearTableIdForEmptyInvoice, showConfirmationAlertCloseSession }) => {
  const { t } = useTranslation()
  return (
    <div className='inline-flex h-16 w-full items-center justify-start gap-6 border-b border-[#e8e8e8] bg-white px-8 py-3'>
      <div className='flex h-10 shrink grow basis-0 items-center justify-between'>
        <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
          <Link
            to='/pos-session'
            className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'
            onClick={(e) => {
              e.preventDefault()
              handleClearTableIdForEmptyInvoice()
            }}
          >
            <ImageWithBasePath src='assets/img/POS/arrow-left.svg' alt='' />
          </Link>
        </div>
        <div className="font-['Inter'] text-xl font-medium text-[#0e121b]">
          {t('table')} # {orderDetail?.table_id?.display_name}
        </div>

        <div className='flex items-center justify-between gap-2 rounded-lg p-2'>
          <Link
            to='#'
            className='btn btn-success'
            onClick={(e) => {
              e.preventDefault()
              handleClearTableIdForEmptyInvoice()
            }}
          >
            <span className='d-flex align-items-center me-1'>
              <Table className='feather-16' />
              {t('view_table')}
            </span>
          </Link>
          <Link
            to='#'
            className='btn btn-info'
            data-bs-toggle='modal'
            data-bs-target='#tableModal'
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <span className='d-flex align-items-center justify-content-center me-1 gap-1'>
              <RotateCw className='feather-16' />
              {t('change_table')}
            </span>
          </Link>
          <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-[#f8f8f8] p-2'>
            <div className='inline-flex shrink grow basis-0 items-center justify-center self-stretch'>
              <div
                className='dropdown pos-menu-action'
                onClick={(e) => {
                  e.preventDefault()
                }}
              >
                <Link
                  className='dropdown-toggle'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                  onClick={(e) => {
                    e.preventDefault()
                  }}
                >
                  <ImageWithBasePath src='assets/img/POS/setting-2.svg' alt='' />
                </Link>
                <ul className='dropdown-menu'>
                  <li>
                    <Link
                      to='#'
                      className='dropdown-item'
                      onClick={(e) => {
                        showConfirmationAlertCloseSession()
                        e.preventDefault()
                      }}
                    >
                      <span className='d-flex align-items-center me-1'>
                        <X className='feather-16 mr-2' />
                        {t('close_session')}
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to='/pos-session' className='dropdown-item'>
                      <span className='d-flex align-items-center me-1'>
                        <ArrowLeft className='feather-16 mr-2' />
                        {t('back')}
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PosNav
